import { render } from "./GenericChartWithApi.vue?vue&type=template&id=61d10cab&ts=true"
import script from "./GenericChartWithApi.vue?vue&type=script&lang=ts"
export * from "./GenericChartWithApi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__